import Vue from "vue";
import Vuex from "vuex";
import Service from "@/service/api-hr";
import router from "@/router/index";
import store from "@/store/store";

const ServerModule = {
    namespaced: true,
    state: {
        item : [],
    },

    mutations: {
        item(state, obj) {
            state.item = obj;
        }
    },

    actions: {
        config({commit}, data) {
            Service.agencyChart('exp', data, {})
                .then((response) => {
                    store.commit("agencyChart/item", response.data.data)
                }).catch((err) => {
            });
        },
        create({commit}, data) {
            Service.agencyChart('post', data, {})
                .then((response) => {
                    // store.commit("agencyChart/affiliation", response.data.data)
                }).catch((err) => {
            });
        },
        update({commit}, data) {
            store.commit("dialog/loading",true)
            Service.agencyChart('put', data, {})
                .then((response) => {
                    store.commit("dialog/loading",false)
                    store.commit("dialog/toasts",1)
                    store.commit("agencyChart/item", response.data.data)
                }).catch((err) => {

                store.commit("dialog/loading",false)
            });
        }
    },

    getters: {
        item(state, obj) {
            return state.item;
        },
    },
};

export default ServerModule;
